import { render, staticRenderFns } from "./SubjectPoolGrid.vue?vue&type=template&id=71988a55"
import script from "./SubjectPoolGrid.vue?vue&type=script&lang=js"
export * from "./SubjectPoolGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports